import React from 'react'
import 'animate.css/animate.css'

export default class ImageModal extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      isActive: false,
      hasImageLoaded: false
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.image !== this.props.image) {
      this.setState({ ...this.state, isActive: true })
    }
  }

  handleImageLoaded = () => {
    setTimeout(() => {
      this.setState({ ...this.state, hasImageLoaded: true })
    }, 250);
  }

  close = () => {
    this.setState({ ...this.state, isActive: false, hasImageLoaded: false })
  }

  render () {
    return (
      <div className={`modal ${ this.state.isActive? 'is-active' : '' }`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <div className="image is-4by3">
            <img src={ this.props.image } alt="" onLoad={ this.handleImageLoaded } />
            { this.state.hasImageLoaded?
                <div className="is-overlay-xy animated fadeInUp">
                  <span className="ans">{ this.props.answer }</span>
                </div>
              :
                <div className="is-overlay-xy">
                  <span className="loding ans">...</span>
                </div>
             }
          </div>
        </div>
        <button className="modal-close is-large" aria-label="close" onClick={ this.close }></button>
      </div>
    )
  }
}
